/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcFundingV1SourceQueryServiceSourceListResponse, IxcFundingV1SourceQueryServiceSourceListSourceListRequest } from '@interxfi/types';

export const IXC_FUNDING_V1_SOURCE_QUERY_SERVICE_SOURCE_LIST_AUDIENCE = ['clearing', 'program'];

export async function ixcFundingV1SourceQueryServiceSourceList(baseUrl: string | undefined, request?: IxcFundingV1SourceQueryServiceSourceListSourceListRequest, requestInit?: RequestInit): Promise<IxcFundingV1SourceQueryServiceSourceListResponse | undefined> { return makeRequest<IxcFundingV1SourceQueryServiceSourceListResponse, IxcFundingV1SourceQueryServiceSourceListSourceListRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/funding/v1/source/q', request, requestInit)); }

